import { render } from "./RefreshIcon.vue?vue&type=template&id=7a4931ee"
import script from "./RefreshIcon.vue?vue&type=script&lang=js"
export * from "./RefreshIcon.vue?vue&type=script&lang=js"
script.render = render

export default script